module.exports = __webpack_public_path__ + "img/mabat-png.da512c36.svg";